import { inject } from "vue";
import store from "@/store";

const useMarkAsFavorite = () => {
  const eventBus: any = inject("eventBus");
  const toggleFavorite = async ({ newsItem, authJWT }) => {
    try {
      await store.dispatch("newsItems/toggleFavorite", { newsItem, authJWT });
    } catch (e) {
      console.error(e);
      eventBus.$emit("appMessage", {
        model: true,
        text: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
      });
    }
  };
  return { toggleFavorite };
};
export default useMarkAsFavorite;
